import React, { FC } from 'react'
import image from './assets/model_availibility.jpg'
import { Box, Image, Container } from '@components/gassan-ui'
import { Heading, Text } from '@rolex-ui'
import { rem } from 'polished'
import { useLocalization } from '@components/Localization'

const ModelAvailability: FC = () => {
  const { lang } = useLocalization()
  return (
    <Box bg="#f8f8f8" py={{ _: rem(50), large: rem(100) }} id="model-availability" mt="10vh">
      <Container maxWidth={rem(650)} textAlign="center">
        <Image ratio={0.58} sources={[image]} />
        <Box mt="1.25rem">
          <Heading variant="mediumTitle" mb="1.25rem">
            {lang === 'nl' ? 'Beschikbaarheid van de modellen' : 'Model availability'}
          </Heading>
          <Text>
            {lang === 'nl'
              ? `Alle Rolex-horloges worden met de grootst mogelijke zorg met de hand geassembleerd om de uitzonderlijke kwaliteit te kunnen waarborgen. Deze hoge vereisten beperken vanzelfsprekend de productiecapaciteit en soms is de vraag naar onze horloges groter dan de productiecapaciteit.

              Om deze reden kan de beschikbaarheid van sommige modellen beperkt zijn. Nieuwe Rolex-horloges worden uitsluitend verkocht door officiële Rolex-retailers. Zij worden regelmatig geleverd en beheren zelfstandig de toewijzing en verkoop aan hun klanten.
              
              Gassan is er trots op deel uit te maken van het wereldwijde netwerk van officiële Rolex-retailers en kan u informeren over de beschikbaarheid van Rolex-horloges.`
              : `All Rolex watches are assembled by hand with the utmost care to ensure exceptional quality. Such high standards naturally restrict Rolex production capacity and, at times, the demand for Rolex watches outpaces this capacity. 
              
              Therefore, the availability of certain models may be limited. New Rolex watches are exclusively sold by Official Rolex Retailers, who receive regular deliveries and independently manage the allocation and sales of watches to customers.
              
              Gassan is proud to be part of the worldwide network of Official Rolex Retailers and can provide information on the availability of Rolex watches.`}
          </Text>
        </Box>
      </Container>
    </Box>
  )
}

export default ModelAvailability
